module.exports = __webpack_public_path__ + "img/desktop-neck-15_28x212.c2a7ee53.png";